const BrandStatus = ({ status = '', displayStatus = '', url = '' } = {}) => ({
  status: String(status),
  displayStatus: String(displayStatus),
  url: String(url),
});

const UniversalStatus = ({ message = '', partialMessages = [] } = {}) => ({
  message: String(message),
  partialMessages: partialMessages.map((item) => item),
});

const OverviewStatus = ({ status = '', displayStatus = '', publishedCount = 0 } = {}) => ({
  status: String(status),
  displayStatus: String(displayStatus),
  publishedCount: Number(publishedCount),
});

const Syndication = ({
  hotpads = {},
  trulia = {},
  zillow = {},

  // external
  realtor = {},
  rent = {},
  redfin = {},
  apartmentGuide = {},

  universal = {},
  overview = {},
  customerProblems = [],
} = {}) => ({
  hotpads: BrandStatus(hotpads),
  trulia: BrandStatus(trulia),
  zillow: BrandStatus(zillow),

  // external
  realtor: BrandStatus(realtor),
  rent: BrandStatus(rent),
  redfin: BrandStatus(redfin),
  apartmentGuide: BrandStatus(apartmentGuide),

  universal: UniversalStatus(universal),
  overview: OverviewStatus(overview),
  customerProblems: customerProblems.map((item) => item),
});

export default Syndication;

export type SyndicationProps = ReturnType<typeof Syndication>;
